import { Paginator, PaginatorProps } from "../paginator";
import { ListDetailBackBar } from "../listDetailBackBar";
import { TitleBar, TitleBarProps } from "../titleBar";
import { useListDetailLayout } from "../../hooks";
import "./ItemsListDetail.scss";
import { ReactElement } from "react";

export const ItemsListDetail = (props: ItemsListDetailProps) => {
  const { showList, showDetail, isDesktop } = useListDetailLayout(
    props.currentId,
  );
  const showDesktopDetail = isDesktop && !!props.currentId;
  const showDetailPanel = !isDesktop ? showDetail : showDesktopDetail;

  const textSearch = (textToSearch: string) => {
    if (!props.title.textSearch) return;
    props.title.textSearch(textToSearch);
  };

  const filterButtonClick = () => {
    if (!props.title.filterButtonClick) return;
    props.title.filterButtonClick();
  };

  return (
    <div className="row items-list-detail">
      {(!props.currentId || isDesktop) && (
        <TitleBar
          title={props.title.title}
          className={props.title.className}
          actions={props.title.actions}
          textSearch={textSearch}
          textSearchToolTip={props.title.textSearchToolTip}
          canFilterButton={props.title.canFilterButton}
          filterButtonToolTip={props.title.filterButtonToolTip}
          filterButtonClick={filterButtonClick}
        />
      )}

      {showList && (
        <div
          className={`col-12 ${
            showDetailPanel ? "col-lg-7" : "col-lg-12"
          } left-side ${props.leftSide.className}`}
        >
          <div className="row">
            <div className="col-12 item-list-container">
              {props.leftSide.component}
            </div>
            <div className="col-12 pager-container pt-2">
              <Paginator
                itemsPerPage={props.paginator.itemsPerPage}
                currentPage={props.paginator.currentPage}
                totalItems={props.paginator.totalItems}
                onNextPage={props.paginator.onNextPage}
                onPreviousPage={props.paginator.onPreviousPage}
                onItemsPerPageChange={props.paginator.onItemsPerPageChange}
              />
            </div>
          </div>
        </div>
      )}

      {showDetailPanel && (
        <div
          className={`col-12 col-lg-5 right-side ${props.rightSide.className}${isDesktop ? " no-padding-right" : ""}`}
        >
          <div className="row">
            <div className="col-12 item-view-container">
              {!isDesktop && props.onBack && props.backLabel && (
                <ListDetailBackBar
                  label={props.backLabel}
                  onBack={props.onBack}
                />
              )}
              {props.rightSide.component}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

interface ItemsListDetailProps {
  leftSide: ItemsListDetailComponent;
  rightSide: ItemsListDetailComponent;
  title: TitleBarProps;
  paginator: PaginatorProps;
  currentId?: string;
  onBack?: () => void;
  backLabel?: string;
}

interface ItemsListDetailComponent {
  className: string;
  component: ReactElement;
}
